import React from 'react';
import { CustomLoader } from '../../components/CustomLoader';
import Page, { Media, MediaContextProvider } from '../../components/Page';
import { offeredOptions } from './PlanDescriptionData';
import { Button, Container, Header, Table } from 'semantic-ui-react';
import {
  DesktopPriceTableHeaderRow,
  DesktopPriceAmountRow,
  DesktopOptionDescriptionRow,
  MobilePriceCards
} from './PricesComponents';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { FirebaseAuthService } from '../../services/AuthService';
import PAYEarned from '../../components/PAYEarned';
import BillingInfo from '../../components/BillingInfo';
import { Payment, Plan } from '../../services/PaymentService';


interface DisplayPricesPageProps {
  auth?: FirebaseAuthService;
  plans: Plan[]; 
}

interface DisplayPricesPageState {
  plans: Plan[];
  loading: boolean;
}

export default class DisplayPricesPage extends React.Component<DisplayPricesPageProps, DisplayPricesPageState> {
  state: DisplayPricesPageState = {
    plans: [],
    loading: true
  };

  async componentDidMount() {
    try {
      const plans = await Payment.getPaymentPlans(); 
      this.setState({ plans, loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.error('Failed to load payment plans:', error);
    }
  }

  render(): JSX.Element {
    const { plans, loading } = this.state;
    if (loading) {
      return (
        <MediaContextProvider>
          <CustomLoader />
        </MediaContextProvider>
      );
    }
    return (
      <MediaContextProvider>
        <DesktopDisplayPricesPage auth={this.props.auth} plans={plans} />
        <MobileDisplayPricesPage auth={this.props.auth} plans={plans} />
      </MediaContextProvider>
    );
  }
}

interface DesktopProps extends DisplayPricesPageProps {
  plans: Plan[];
}

@inject('auth')
@observer
class DesktopDisplayPricesPage extends React.Component<DesktopProps> {

  render(): React.ReactNode {
    const { auth, plans } = this.props;
    const routeForGetStarted =  '/subscription/select' ;
    console.log("routeForGetStarted",this.props, routeForGetStarted );
    
    return (
      <Media greaterThan='mobile'>
        <Page>
          <Header as="h2"><PAYEarned /> Pricing</Header>
          <Container textAlign='center'>
            <Button color="green" size="medium" as={Link} to={routeForGetStarted} style={{ marginLeft: '10px' }}><strong>Subscribe Now</strong></Button>
          </Container>

          <Table celled structured style={ { marginTop: 30 } }>
            <Table.Header celled structured>
              <DesktopPriceTableHeaderRow  plans={plans} />
  
            </Table.Header>
            <Table.Body>
              <DesktopPriceAmountRow  plans={plans} />
              {
                offeredOptions.map(option => <DesktopOptionDescriptionRow
                  key={ option.id }
                  option={ option }
                />)
              }
            </Table.Body>
          </Table>
          <p><b>No Risk</b></p>
          <BillingInfo />
        </Page>
      </Media>
    );
  }
}

@inject('auth')
@observer
class MobileDisplayPricesPage extends React.Component<DesktopProps> {

  render(): React.ReactNode {
    const { auth, plans } = this.props;
    const routeForGetStarted = (this.props.auth?.initialized && this.props.auth?.user?.id) ? '/subscription/select' : '/signup';

    return (
      <Media at={ 'mobile' }>
        <Page>
          <Header as="h2"><PAYEarned /> Pricing</Header>
          <Container textAlign='center'>
            <Button color="green" size="medium" as={Link} to={routeForGetStarted} style={{ marginLeft: '10px' }}><strong>Subscribe Now</strong></Button>
          </Container>
          <MobilePriceCards plans={plans} />
          <p><span style={ { color: 'red' } }>*</span><b>No Risk</b></p>
          <BillingInfo />
        </Page>
      </Media>
    );
  }
}

